import { API_URL } from '../BaseUrl';

export const EDIT_PROFILE_URL = `${API_URL}/users`;
export const CHANGE_PASSWORD_URL = `${API_URL}/change_password`;
